export const queryKeys = {
  REASONS: 'REASONS',
  EMPLOYEES: 'EMPLOYEES',
  TIME_OFF_LIST: 'TIME_OFF_LIST',
  TIME_OFF_DAILY: 'TIME_OFF_DAILY',
  TIME_OFF_WEEKLY: 'TIME_OFF_WEEKLY',
  TIME_OFF_MONTHLY: 'TIME_OFF_MONTHLY',
  EMPLOYEES_SELECT: 'EMPLOYEES_SELECT',
}
